/**
 * 统一机台码解析：运维粘贴的后台短码（localStorage / Tauri 配置文件）
 *
 * 业务机台码与设备指纹分离：不再用 Tauri 硬件 ID 覆盖本地配置。
 */

import { getMachineCodeFallback } from '@/utils/env'
import { getMachineId, isTauri } from '@/utils/tauri-bridge'

const LS_KEY = 'kiosk_machine_code'

/** 同步读取（localStorage / fallback），不含 Tauri 异步查询 */
export function getEffectiveMachineCodeSync(): string {
  if (typeof localStorage !== 'undefined') {
    const stored = localStorage.getItem(LS_KEY)
    if (stored?.trim()) return stored.trim()
  }
  return getMachineCodeFallback()
}

function persist(code: string): void {
  if (typeof localStorage !== 'undefined') {
    localStorage.setItem(LS_KEY, code)
  }
}

/** 异步解析：Tauri 读本机已粘贴的短码；空则回落 localStorage */
export async function resolveMachineCode(): Promise<string> {
  if (isTauri()) {
    try {
      const id = await getMachineId()
      if (id?.trim()) {
        persist(id.trim())
        return id.trim()
      }
    } catch {
      // 降级到 localStorage / fallback
    }
  }

  return getEffectiveMachineCodeSync()
}

/** 写入业务机台码（运维页粘贴后台短码） */
export function setLocalMachineCode(code: string): void {
  persist(code.trim())
}

/** 生成短机台码（与游戏厅 / 管理后台规则一致：KG-XXX-XXXX） */
export function generateMachineCode(): string {
  const alphabet = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789'
  const pick = (n: number) =>
    Array.from({ length: n }, () => alphabet[Math.floor(Math.random() * alphabet.length)]).join('')
  return `KG-${pick(3)}-${pick(4)}`
}
